export { default } from './ThumbtackCategoryItem';
